import React from 'react'
import styled from "styled-components";
import { List, ListItem, ListItemText } from 'components/ui'
import { handleLogout } from "@root/redux/features/sessions/actions";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import colors from 'styles/colors';
import { canAccess } from 'utils/permissions';
import roles from 'utils/roles';

const Nav = styled.nav`
  display: flex;
  width: 320px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: ${colors.punch[600]};
`;

const Spacing = styled.div`
  display: flex;
  width: 8px;
  flex-direction: column;
  align-items: flex-start;
`;

const MinHeight = styled.div`
  width: 1px;
  height: 16px;
`;

const Ui = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

const List1 = styled(List)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  margin-bottom: 100px !important;
  height: 510px;
`;

const ListContainer = styled.div`
  display: flex;
  padding: 0 16px;
  align-items: center;
  align-self: stretch;
  color: #ffffff;
`;

const ListContent = styled(ListItem)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  cursor: default;
`

const LeftContent = styled.div`
  display: flex;
  min-width: 56px;
  flex-direction: column;
  align-items: flex-start;
`;

const List2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const Sidenav = (props) => {
  const { user } = props;
  let navigate = useNavigate()

  const handleClick = (link) => {
    window.location.href = link;
  };

  const handleClickLogout = () => {
    handleLogout(navigate);
  };

  return (
    <Nav>
      <Spacing>
        <MinHeight />
      </Spacing>
      <Ui>
        <List1 component="nav">
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.financial, roles.recruiter, roles.hr_business_partner, roles.personal_department, roles.supervisor]) &&
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/empresas/dashboard')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">home</span>
                </LeftContent>
                <ListItemText primary="Home" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.supervisor, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/avaliacoes/respostas')}>
              <ListContainer>
                <LeftContent>
                  <span class="material-symbols-rounded">emoji_events</span>
                </LeftContent>
                <ListItemText primary="Avaliação de estágio" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.recruiter]) &&
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/candidatos')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">patient_list</span>
                </LeftContent>
                <ListItemText primary="Banco de candidatos" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.hr_business_partner, roles.personal_department]) &&
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/eventos')}>
              <ListContainer>
                <LeftContent>
                  <span class="material-symbols-rounded">3p</span>
                </LeftContent>
                <ListItemText primary="Eventos e feiras" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.financial]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/financeiro/relatorios-da-empresa')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">payments</span>
                </LeftContent>
                <ListItemText primary="Financeiro" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.financial, roles.recruiter, roles.hr_business_partner, roles.supervisor, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick(`/empresas/ver/${user?.company_slug}`)}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">dvr</span>
                </LeftContent>
                <ListItemText primary="Meu portal" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.hr_business_partner, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/folders/minhas')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">folder_open</span>
                </LeftContent>
                <ListItemText primary="Meus contratos" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.recruiter]) &&
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/vagas/minhas')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">cases</span>
                </LeftContent>
                <ListItemText primary="Minhas vagas" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.recruiter]) &&
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/programa_estagio')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">business_center</span>
                </LeftContent>
                <ListItemText primary="Programas de estágio" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.financial, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/folders/kpis')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">finance</span>
                </LeftContent>
                <ListItemText primary="Relatórios" />
              </ListContainer>
            </ListContent>
          }
        </List1>
        <List2>
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.financial, roles.recruiter, roles.hr_business_partner, roles.supervisor, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick(`/gestores/${user.uuid}/editar`)}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">person</span>
                </LeftContent>
                <ListItemText primary="Meu perfil" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.financial, roles.recruiter, roles.hr_business_partner, roles.supervisor, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/gestores/editar')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">lock</span>
                </LeftContent>
                <ListItemText primary="Alterar senha" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/gestores/minhas')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">groups</span>
                </LeftContent>
                <ListItemText primary="Meus colaboradores" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/empresas/editar')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">settings</span>
                </LeftContent>
                <ListItemText primary="Configurações" />
              </ListContainer>
            </ListContent>
          }
          {canAccess(user?.roles, [roles.administrator, roles.representative, roles.financial, roles.recruiter, roles.hr_business_partner, roles.supervisor, roles.personal_department]) && 
            <ListContent button dense={false} disableGutters={true} divider={false} onClick={() => handleClick('/candidatos')}>
              <ListContainer>
                <LeftContent>
                  <span className="material-symbols-rounded">chat_info</span>
                </LeftContent>
                <ListItemText primary="Fale conosco" />
              </ListContainer>
            </ListContent>
          }
          <ListContent button dense={false} disableGutters={true} divider={false} onClick={handleClickLogout}>
            <ListContainer>
              <LeftContent>
                <span className="material-symbols-rounded">logout</span>
              </LeftContent>
              <ListItemText primary="Sair" />
            </ListContainer>
          </ListContent>
        </List2>
      </Ui>
      <Spacing>
        <MinHeight />
      </Spacing>
    </Nav>
  )
}

function mapStateToProps(state) {
  const user = state.session?.attributes;
  return { user };
}

export default connect(mapStateToProps)(Sidenav);